import { createSlice } from "@reduxjs/toolkit";

const initialWalletTabUserProfileNewState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  currencyList: [],
  userInfo: {},
  totalCreditDebitData: [],
  userTotalCreditDebitData: [],
  userWalletData: [],
  walletListLoading: false
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const WalletTabUserProfileNewSlice = createSlice({
  name: "walletTabUserProfileNew",
  initialState: initialWalletTabUserProfileNewState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.userWalletData = [];
    },

    usersLedgerWalletList: (state, action) => {
      const { totalCount, entities, totalCreditDebitData } = action.payload;
      // Ensure that the "contest" data is transformed and added to entities
      const updatedEntities = entities.map((entity) => ({
        ...entity,
        contest: entity.contest || "N/A",
      }));
      state.listLoading = false;
      state.error = null;
      state.entities = updatedEntities; // Use the updatedEntities array
      state.totalCount = totalCount;
      state.totalCreditDebitData = totalCreditDebitData;
    },

    currencyList: (state, action) => {
      const { currencyList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.currencyList = currencyList || [];
    },
    singleNameFetched: (state, action) => {
      state.actionsLoading = false;
      state.userInfo = action.payload?.userInfo;
      state.error = null;
    },

    PartnerList: (state, action) => {
      const { partnerList } = action.payload;
      state.listLoading = false;
      state.error = null;
      // state.totalCount = 0;
      state.partnerList = partnerList;
    },
      
    usersLedgerWalletSummary: (state, action) => {
      const { userTotalCreditDebitData } = action.payload;
      state.listLoading = false;
      state.walletListLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.userTotalCreditDebitData = userTotalCreditDebitData;
      state.userWalletData = []
    },
    usersLedgerWalletDetailLoading: (state, action) => {
      state.walletListLoading = true;
    },
    usersLedgerWalletDetails: (state, action) => {
      const { totalCount, userWalletData } = action.payload;

      const updatedEntities = userWalletData.map((entity) => ({
        ...entity,
        contest: entity.contest || "N/A",
      }));

      state.walletListLoading = false;
      state.listLoading = false;
      state.error = null;
      state.totalCount = totalCount;
      state.userWalletData = updatedEntities
    },
  },
});
